import { FormControl, FormLabel, Input, VStack } from '@chakra-ui/react';
import React from 'react';
import { Control, UseFormRegister, useFieldArray } from 'react-hook-form';

type MultilabelInputProps = {
  control: Control<MultilabelInputFieldValues>;
  register: UseFormRegister<MultilabelInputFieldValues>;
};

type MultilabelInputFieldValues = {
  labels: { key: string; value: string }[];
};

export default function MultilabelInput({
  control,
  register,
}: MultilabelInputProps): React.ReactElement {
  //Arguably no longer a dynamic form.
  const { fields } = useFieldArray({
    control,
    name: 'labels',
  });

  return (
    <React.Fragment>
      <VStack paddingTop={2} width={'100%'}>
        {fields.map((field, index) => (
          <React.Fragment key={field.id}>
            <FormControl>
              <FormLabel> {field.key}</FormLabel>
              <Input
                {...register(`labels.${index}.value` as const)}
                placeholder="Value"
                flex={1}
              />
            </FormControl>
          </React.Fragment>
        ))}
      </VStack>
    </React.Fragment>
  );
}
